/**
 * Linking Bundle Products on the Homepage to redirect to Product Pages instead of Collection Pages
 */
document.addEventListener("DOMContentLoaded", function() {
  const linkMap = {
    "/collections/night-shift": "/products/bundle-night-shift",
    "/collections/sculpt-society": "/products/bundle-sculpt-society",
    "/collections/flight-club": "/products/bundle-flight-club",
    "/collections/clean-canvas": "/products/bundle-clean-canvas"
  };

  // Find all links across the page and swap their destinations instantly
  document.querySelectorAll('a[href]').forEach(link => {
    let currentHref = link.getAttribute('href');
    if (currentHref) {
      // Correct syntax: split away parameters, take the first string part
      let urlPath = currentHref.split('?')[0].split('#')[0];
      
      if (linkMap[urlPath]) {
        link.setAttribute('href', linkMap[urlPath]);
      }
    }
  });
});

// Automatically redirects users from the Collection/All page to Collectiion/Shop All page
if (window.location.pathname === '/collections/all') {
  window.location.href = '/collections/shop-all';
}

// Rewrites any link paths on the current page pointing to /collections/all on the fly
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('a[href]').forEach(link => {
    const currentHref = link.getAttribute('href');
    if (currentHref && currentHref.split('?')[0] === '/collections/all') {
      link.setAttribute('href', '/collections/shop-all');
    }
  });
});


/*Change Promo Code Button on Cart Drawer & Add Payment Cards Below Checkout Button*/
/*document.addEventListener("DOMContentLoaded", function() {
  function setupInlineCartDrawer() {
    if (document.querySelector('.js-promo-processed')) return;

    const promoBtn = document.querySelector('button.btn.btn--secondary.btn--small[aria-controls*="cart-drawer"]');
    const discountInput = document.querySelector('input[name="discount"]');
    
    if (promoBtn && discountInput) {
      const discountFormWrapper = discountInput.closest('form') || discountInput.parentElement;
      discountFormWrapper.classList.add('js-promo-processed');
      
      promoBtn.parentNode.insertBefore(discountFormWrapper, promoBtn);
      
      discountFormWrapper.style.setProperty('display', 'flex', 'important');
      discountFormWrapper.style.setProperty('flex-direction', 'row', 'important');
      discountFormWrapper.style.setProperty('visibility', 'visible', 'important');
      discountFormWrapper.style.setProperty('opacity', '1', 'important');
    }

    // Inject the unified image strip directly under the Checkout button
    const checkoutButtons = Array.from(document.querySelectorAll('button, a'));
    const checkoutBtn = checkoutButtons.find(el => el.textContent.includes('CHECKOUT'));

    if (checkoutBtn && !document.querySelector('.cart-drawer-payment-badges-strip')) {
      const stripContainer = document.createElement('div');
      stripContainer.className = 'cart-drawer-payment-badges-strip';
      
      // Load your exact Shopify CDN image strip file
      stripContainer.innerHTML = `
        <img src="https://cdn.shopify.com/s/files/1/0951/9339/9562/files/payment_cards_new.png?v=1789595253" alt="Accepted Payments" />
      `;
      
      checkoutBtn.parentNode.insertAdjacentElement('afterend', stripContainer);
    }
  }

  setupInlineCartDrawer();
  
  document.addEventListener('click', function(e) {
    if (e.target.closest('[href*="/cart"]') || e.target.closest('[aria-controls*="cart"]') || e.target.closest('.btn--secondary')) {
      setTimeout(setupInlineCartDrawer, 400);
    }
  });
});
*/
/*fixed the promo disappearing or cart drawer update*/
/*document.addEventListener("DOMContentLoaded", function() {
  let isAdjusting = false; // Flag to prevent infinite layout loops

  function setupInlineCartDrawer() {
    // If we are already adjusting the DOM in this cycle, exit early
    if (isAdjusting) return;

    const promoBtn = document.querySelector('button.btn.btn--secondary.btn--small[aria-controls*="cart-drawer"]');
    const discountInput = document.querySelector('input[name="discount"]');
    
    if (promoBtn && discountInput) {
      const discountFormWrapper = discountInput.closest('form') || discountInput.parentElement;
      
      // Re-apply if the layout doesn't have our active class OR isn't positioned correctly
      if (!discountFormWrapper.classList.contains('js-promo-processed') || discountFormWrapper.nextElementSibling !== promoBtn) {
        isAdjusting = true; // Lock observer tracking
        
        discountFormWrapper.classList.add('js-promo-processed');
        promoBtn.parentNode.insertBefore(discountFormWrapper, promoBtn);
        
        discountFormWrapper.style.setProperty('display', 'flex', 'important');
        discountFormWrapper.style.setProperty('flex-direction', 'row', 'important');
        discountFormWrapper.style.setProperty('visibility', 'visible', 'important');
        discountFormWrapper.style.setProperty('opacity', '1', 'important');
        
        isAdjusting = false; // Unlock observer tracking
      }
    }

    // Inject the unified image strip directly under the Checkout button
    const checkoutButtons = Array.from(document.querySelectorAll('button, a'));
    const checkoutBtn = checkoutButtons.find(el => el.textContent && el.textContent.includes('CHECKOUT'));

    if (checkoutBtn && !document.querySelector('.cart-drawer-payment-badges-strip')) {
      isAdjusting = true;
      
      const stripContainer = document.createElement('div');
      stripContainer.className = 'cart-drawer-payment-badges-strip';
      stripContainer.innerHTML = `
        <img src="https://cdn.shopify.com/s/files/1/0951/9339/9562/files/payment_cards_new.png?v=1789595253" alt="Accepted Payments" />
      `;
      
      checkoutBtn.parentNode.insertAdjacentElement('afterend', stripContainer);
      
      isAdjusting = false;
    }
  }

  // Initial execution run
  setupInlineCartDrawer();
  
  // Lightweight background observer targeting only container refreshes
  const cartDrawerContainer = document.querySelector('.cart-drawer');
  if (cartDrawerContainer) {
    const dynamicObserver = new MutationObserver(function(mutations) {
      if (isAdjusting) return;
      
      // Only execute if nodes were added or removed (like an AJAX redraw)
      for (let mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          setupInlineCartDrawer();
          break;
        }
      }
    });
    dynamicObserver.observe(cartDrawerContainer, { childList: true, subtree: true });
  }
  
  document.addEventListener('click', function(e) {
    if (e.target.closest('[href*="/cart"]') || e.target.closest('[aria-controls*="/cart"]') || e.target.closest('.btn--secondary')) {
      setTimeout(setupInlineCartDrawer, 400);
    }
  });
});
*/

document.addEventListener("DOMContentLoaded", function() {
  let isAdjusting = false; // Flag to prevent infinite layout loops

  function setupInlineCartDrawer() {
    // If we are already adjusting the DOM in this cycle, exit early
    if (isAdjusting) return;

    // FIX: Scope the search layout strictly within the cart drawer container element
    const drawerContainer = document.querySelector('.cart-drawer');
    if (!drawerContainer) return;

    const promoBtn = drawerContainer.querySelector('button.btn.btn--secondary.btn--small[aria-controls*="cart-drawer"]');
    const discountInput = drawerContainer.querySelector('input[name="discount"]');
    
    if (promoBtn && discountInput) {
      const discountFormWrapper = discountInput.closest('form') || discountInput.parentElement;
      
      // Re-apply if the layout doesn't have our active class OR isn't positioned correctly
      if (!discountFormWrapper.classList.contains('js-promo-processed') || discountFormWrapper.nextElementSibling !== promoBtn) {
        isAdjusting = true; // Lock observer tracking
        
        discountFormWrapper.classList.add('js-promo-processed');
        promoBtn.parentNode.insertBefore(discountFormWrapper, promoBtn);
        
        discountFormWrapper.style.setProperty('display', 'flex', 'important');
        discountFormWrapper.style.setProperty('flex-direction', 'row', 'important');
        discountFormWrapper.style.setProperty('visibility', 'visible', 'important');
        discountFormWrapper.style.setProperty('opacity', '1', 'important');
        

        


        isAdjusting = false; // Unlock observer tracking
      }
    }

    // FIX: Scan for buttons strictly inside the cart drawer container layout boundary
    const checkoutButtons = Array.from(drawerContainer.querySelectorAll('button, a'));
    const checkoutBtn = checkoutButtons.find(el => el.textContent && el.textContent.includes('CHECKOUT'));

    if (checkoutBtn) {
      isAdjusting = true;
      
      // Dynamically locate the inner span text box to update wording to 'VIEW BAG & CHECKOUT' safely
      const checkoutTextSpan = checkoutBtn.querySelector('.btn__text');
      if (checkoutTextSpan && checkoutTextSpan.textContent !== 'VIEW BAG & CHECKOUT') {
        checkoutTextSpan.textContent = 'VIEW BAG & CHECKOUT';
      } else if (!checkoutTextSpan && checkoutBtn.textContent !== 'VIEW BAG & CHECKOUT') {
        checkoutBtn.textContent = 'VIEW BAG & CHECKOUT'; 
      }

      // Check if image strip is already built below the active target
      if (!drawerContainer.querySelector('.cart-drawer-payment-badges-strip')) {
        const stripContainer = document.createElement('div');
        stripContainer.className = 'cart-drawer-payment-badges-strip';
        stripContainer.innerHTML = `
          <img src="https://cdn.shopify.com/s/files/1/0951/9339/9562/files/CARD_ICONS_-NEW_604x48_PIXELS.png?v=1789743796" alt="Accepted Payments" />
        `;
        
        checkoutBtn.parentNode.insertAdjacentElement('afterend', stripContainer);
      }
      
      isAdjusting = false;
    }
  }

  // Initial execution run
  setupInlineCartDrawer();
  
  // Lightweight background observer targeting only container refreshes
  const cartDrawerContainer = document.querySelector('.cart-drawer');
  if (cartDrawerContainer) {
    const dynamicObserver = new MutationObserver(function(mutations) {
      if (isAdjusting) return;
      
      // Only execute if nodes were added or removed (like an AJAX redraw)
      for (let mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          setupInlineCartDrawer();
          break;
        }
      }
    });
    dynamicObserver.observe(cartDrawerContainer, { childList: true, subtree: true });
  }
  
  document.addEventListener('click', function(e) {
    if (e.target.closest('[href*="/cart"]') || e.target.closest('[aria-controls*="/cart"]') || e.target.closest('.btn--secondary')) {
      setTimeout(setupInlineCartDrawer, 400);
    }
  });
});


/*Product Page Discount Badge*/
document.addEventListener("DOMContentLoaded", function() {
  const badgeBlock = document.querySelector('div[data-block-id="badges"]');
  const salePriceContainer = document.querySelector('.f-price__sale');
  if (badgeBlock && salePriceContainer) {
    salePriceContainer.appendChild(badgeBlock);
    const badgeText = badgeBlock.querySelector('.f-badge');
    if (badgeText) {
      badgeText.innerHTML = badgeText.innerHTML.replace(/\.00/g, '');
    }
  }
});

/*Cart Page Title Change & Cart Page Changes to Product Name*/
/*document.addEventListener("DOMContentLoaded", () => {
  if (!localStorage.getItem('eulah_saved_items')) {
    localStorage.setItem('eulah_saved_items', JSON.stringify([]));
  }

  async function formatCartTitles() {
    // 1. Process "Your Cart" to "Your bag"
    document.querySelectorAll('.cart__title, h1.cart-title, h1.title').forEach(titleElement => {
      if (titleElement.innerText.toLowerCase().includes('your cart')) {
        const countElement = titleElement.querySelector('.cart-count, #cart-count');
        if (countElement) {
          titleElement.innerHTML = `Your bag (${countElement.outerHTML})`;
        } else {
          titleElement.innerText = titleElement.innerText.toLowerCase().replace('your cart', 'Your bag');
        }
      }
    });

    const cartTitles = document.querySelectorAll('.cart-item__name, .cart-item__title, [class*="cart-item"] a');
    if (cartTitles.length === 0) return;

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      const cartData = await response.json();
      
      for (const titleElement of cartTitles) {
        if (titleElement.dataset.formatted === "true") continue;
        if (titleElement.classList.contains('cart-remove-item') || titleElement.closest('.cart-remove-item')) continue;
        if (titleElement.classList.contains('product-option') || titleElement.closest('.product-option')) continue;
        if (titleElement.classList.contains('cart-custom-action-btn')) continue;
        
        let fullText = "";
        Array.from(titleElement.childNodes).forEach(node => {
          if (node.nodeType === Node.TEXT_NODE) fullText += node.textContent;
        });
        fullText = fullText.trim();
        if (!fullText) continue;

        const matchingItem = cartData.items.find(item => 
          fullText.toLowerCase().includes(item.product_title.toLowerCase())
        );
        if (!matchingItem) continue;

        const words = fullText.split(/\s+/);
        if (words.length > 3) {
          const line1 = words.slice(0, 2).join(" ");
          const line2 = words.slice(2).join(" ");
          let extractedVolume = "";
          try {
            const productResponse = await fetch(`${window.Shopify.routes.root}products/${matchingItem.handle}.js`);
            const productData = await productResponse.json();
            const descriptionText = productData.description || "";
            const volumeMatch = descriptionText.match(/(\d+(?:\.\d+)?)\s*(ml|g|mg|l|oz)/i);
            if (volumeMatch) {
              extractedVolume = `, ${volumeMatch.toLowerCase()}`;
            }
          } catch (e) {
            console.error("Failed to read product description:", e);
          }

          titleElement.innerHTML = `
            <span class="cart-custom-line-1">${line1}</span>
            <span class="cart-custom-line-2">${line2}${extractedVolume}</span>
          `;
          titleElement.dataset.formatted = "true";
          titleElement.classList.add('cart-custom-title-wrapper');
          
          const titleContainer = titleElement.parentElement;
          if (titleContainer && !titleContainer.querySelector('.cart-custom-actions-row')) {
            const actionsRow = document.createElement('div');
            actionsRow.className = 'cart-custom-actions-row';
            actionsRow.innerHTML = `
              <a href="${window.Shopify.routes.root}cart/change?id=${matchingItem.key}&quantity=0" class="cart-custom-action-btn action-remove">Remove</a>
              <button type="button" class="cart-custom-action-btn action-save" data-id="${matchingItem.id}" data-key="${matchingItem.key}" data-handle="${matchingItem.handle}" data-title="${matchingItem.product_title}" data-img="${matchingItem.image}" data-price="${matchingItem.price}">Save for later</button>
            `;
            titleContainer.appendChild(actionsRow);
          }
        }
      }

      // Bind click handlers for Save for Later action
      document.querySelectorAll('.action-save').forEach(btn => {
        if (btn.dataset.bound === "true") return;
        btn.dataset.bound = "true";
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
          const b = e.target;
          const itemToSave = {
            id: b.dataset.id,
            key: b.dataset.key,
            handle: b.dataset.handle,
            title: b.dataset.title,
            image: b.dataset.img,
            price: b.dataset.price
          };
          let savedItems = JSON.parse(localStorage.getItem('eulah_saved_items'));
          if (!savedItems.some(item => item.id === itemToSave.id)) {
            savedItems.push(itemToSave);
            localStorage.setItem('eulah_saved_items', JSON.stringify(savedItems));
          }
          try {
            await fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: itemToSave.key, quantity: 0 })
            });
            window.location.reload();
          } catch (err) {
            console.error("Error removing item after saving:", err);
          }
        });
      });

    } catch (error) {
      console.error("Failed to parse cart items:", error);
    }
  }

  // Initial execution
  formatCartTitles();

  // Watch for dynamic DOM re-renders securely
  const observer = new MutationObserver(() => formatCartTitles());
  const cartContainer = document.querySelector('form[action="/cart"], #cart-drawer, .cart-drawer, .cart-items, [data-mini-cart-items], .main-cart-wrapper');
  if (cartContainer) {
    observer.observe(cartContainer, { childList: true, subtree: true });
  }

  // Fast Global Interval Loop to completely catch rapid click updates instantly
  setInterval(formatCartTitles, 300);
});
*/


/* Final Footer Newsletter Submission with Explicit Compliance Resubscribe Tracking */
function initOmnisendCustomForm() {
  const customForm = document.getElementById("eulah-custom-news-form");
  if (!customForm || customForm.dataset.omnisendBound === "true") return;
  customForm.dataset.omnisendBound = "true";

  customForm.addEventListener("submit", function (event) {
    event.preventDefault();
    const emailInput = customForm.querySelector(".eulah-news-input").value.trim();
    const submitBtn = customForm.querySelector(".eulah-news-btn");

    if (emailInput && submitBtn) {
      window.omnisend = window.omnisend || [];

      // 1. Generate compliance timestamp to force-override old unsubscribed records
      const isoTimestamp = new Date().toISOString(); 

      const trackingPayload = {
        email: emailInput,
        status: "subscribed",
        statusDate: isoTimestamp, // Explicitly tells Omnisend the subscription state is newer than the old opt-out date
        tags: ["custom_form", "newsletter"],
        consent: {
          email: {
            status: "subscribed",
            statusDate: isoTimestamp,
            source: "footer_newsletter" // Validates external audit trail requirements
          }
        }
      };

      // 2. Transmit identified dataset
      if (window.omnisend.identifyContact && typeof window.omnisend.identifyContact === "function") {
        window.omnisend.identifyContact(trackingPayload);
      } else {
        window.omnisend.push(["identifyContact", trackingPayload]);
      }

      // 3. TRIGGER WELCOME EMAIL: Track custom workflow event
      window.omnisend.push(["track", "custom_newsletter_signup"]);

      // 4. UI Transition
      submitBtn.innerText = "Subscribed!";
      submitBtn.style.pointerEvents = "none"; 
      customForm.reset();

      // 5. Reset UI button loop
      setTimeout(function () {
        submitBtn.innerText = "Sign Up";
        submitBtn.style.pointerEvents = "auto"; 
      }, 5000); 
    }
  });
}



// Monitor execution stages of layout engine lifecycles
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initOmnisendCustomForm);
} else {
  initOmnisendCustomForm();
}
window.addEventListener("load", initOmnisendCustomForm);




